import React, { useState, useEffect } from "react";
import CategoryNamesTable from "./components/CategoryNamesTable";
import Edit from "./modals/Edit";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Divider from "@material-ui/core/Divider";
import axios from "axios";
import { v4 as uuid } from "uuid";

export default function CategoryNames() {
  const [showEdit, setShowEdit] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showCreate, setShowCreate] = useState(false);

  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [categoryName, setCategoryName] = useState({});
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [categoryNameId, setCategoryNameId] = useState(null);
  const [deleteCategoryNamesIds, setDeleteCategoryNamesIds] = useState([]);

  const [orders, setOrders] = useState([]);


  const onCategoryNames = (skip, take, sortField, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}campaign/category?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        }

      ).catch((error) => {
        setIsLoaded(false);
        setError(true);
        setRows([]);
        setCount(0);
      });
  };


  const onCategoryNameChoose = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}campaign/category/${id}`)
      .then(({ data }) => {
        setCategoryName(data);
      });
  };

  const onDeleteCategoryNames = () => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}campaign/category`, {
        headers: {
          "x-requestid": uuid(),
        },
        data: {
          id: deleteCategoryNamesIds,
        },
      })
      .then((res) => {
        setDeleteCategoryNamesIds([]);
        onCategoryNames(skip, take, sortField, orderBy);
      });
  };



  const onUpdateUserStatus = (id, statusType) => {
    let isActive = !statusType;
    axios
      .put(
        `${process.env.REACT_APP_API_URL}campaign/category/changeStatus`,
        {
          id,
          isActive
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onCategoryNames(skip, take, sortField, orderBy);
      });
  };



  const onOrders = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}campaign/orders`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data }) => {
        setOrders(data);
        // console.log(data)
      });
  };

  useEffect(() => {
    onOrders();
  }, []);



  useEffect(() => {

    onCategoryNames(skip, take, sortField, orderBy, orders);
  }, [skip, take, sortField, orderBy, orders]);

  useEffect(() => {
    if (!showEdit) setCategoryName({});
  }, [showEdit]);
  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Category Names</h1>
      </div>
      <Divider className="w-100" />
      <CategoryNamesTable
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        onCategoryNameChoose={onCategoryNameChoose}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        setOpenEdit={setShowEdit}
        setOpenRemove={setShowRemove}
        setOpenCreate={setShowCreate}
        setCategoryNameId={setCategoryNameId}
        setDeleteCategoryNamesID={setDeleteCategoryNamesIds}
        deleteCategoryNamesIds={deleteCategoryNamesIds}
        onDeleteCategoryNames={onDeleteCategoryNames}
        onUpdateUserStatus={onUpdateUserStatus}

      />
      <Edit
        categoryName={categoryName}
        show={showEdit}
        onHide={setShowEdit}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        onCategoryNames={onCategoryNames}
        orders={orders}

      />
      <Delete
        categoryName={categoryName}
        show={showRemove}
        onHide={setShowRemove}
        id={categoryNameId}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        onCategoryNames={onCategoryNames}
      />
      <Create
        show={showCreate}
        onHide={setShowCreate}
        onCategoryNames={onCategoryNames}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}

        orders={orders}

        onOrders={onOrders}

      />
    </div>
  );
}
